import { render, staticRenderFns } from "./InstagramReportPage.vue?vue&type=template&id=1caaf0ad&scoped=true&"
import script from "./InstagramReportPage.vue?vue&type=script&lang=js&"
export * from "./InstagramReportPage.vue?vue&type=script&lang=js&"
import style0 from "./InstagramReportPage.vue?vue&type=style&index=0&id=1caaf0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1caaf0ad",
  null
  
)

export default component.exports